{
  "version": 1,
  "asset_id": "c05d104a-457e-4400-9ed6-f42de4172b9f",
  "project_id": "bc28ec3a-38d3-4a78-848c-5618f322d6de",
  "url": "/__l5e/assets-v1/c05d104a-457e-4400-9ed6-f42de4172b9f/timothy-ng-224.webp",
  "r2_key": "a/v1/bc28ec3a-38d3-4a78-848c-5618f322d6de/c05d104a-457e-4400-9ed6-f42de4172b9f/timothy-ng-224.webp",
  "original_filename": "timothy-ng-224.webp",
  "size": 8192,
  "content_type": "image/webp",
  "created_at": "2026-07-29T18:51:39Z"
}
